// firebaseAuth.js
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  signInWithCustomToken,
} from "firebase/auth";
import { useState, useEffect } from "react";
import app, { getAuthCentral } from "../config/FirebaseConfig";
const auth = getAuth(app);

// Initialize Firebase Auth instance

// Function to log in the user with email and password
export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error) {
    console.error("Error logging in:", error.message);
    throw error; // Throw the error so it can be handled in the component
  }
};

export const logoutUser = async () => {
  try {
    console.warn("logoutUser");
    await signOut(auth); // Log out the user
  } catch (error) {
    console.error("Error logging out:", error.message);
    throw error; // Handle the error wherever this function is called
  }
};

// Custom hook to track auth state
export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true); // Loading indicator

  useEffect(() => {
    const auth = getAuthCentral();

    // Set up the listener
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is logged in
        setCurrentUser(user);
      } else {
        // User is logged out
        setCurrentUser(null);
      }
      setLoading(false); // Loading finished
    });

    // Clean up the listener when the component unmounts
    return unsubscribe;
  }, []);

  return { currentUser, loading };
};

export async function signInAsGuest(token) {
  const auth = getAuthCentral();
  try {
    const userCredential = await signInWithCustomToken(auth, token);
  } catch (error) {
    console.error("Guest sign-in failed:", error);
  }
}
